import TSettingSms from './index.vue';

TSettingSms.install = app => {
  app.component(TSettingSms.name, TSettingSms);
};

export default TSettingSms;
